import {
  type BooleanDynamicConfig,
  type NumericDynamicConfig,
  useViewerOrgsBooleanDynamicConfig,
  useViewerOrgsNumericDynamicConfig,
} from '../useDynamicConfig';

/**
 * Returns whether MinMaxLast plotting mode is enabled via the
 * `history_line_feature_flags` Statsig dynamic config. True if any of
 * the viewer's organizations has `enableMinMaxLastMode` set to true.
 */
export const useEnableMinMaxLastMode = (): BooleanDynamicConfig => {
  return useViewerOrgsBooleanDynamicConfig(
    'history_line_feature_flags',
    'enableMinMaxLastMode'
  );
};

/**
 * Returns the maximum `line_plot_max_runs` value configured across all of
 * the viewer's organizations via the `line_plot_increased_max_runs` Statsig
 * dynamic config. Uses the 'max' strategy so the most permissive org wins.
 */
export const useLinePlotMaxRunsDynamicConfig = (): NumericDynamicConfig => {
  return useViewerOrgsNumericDynamicConfig(
    'line_plot_increased_max_runs',
    'line_plot_max_runs',
    'max'
  );
};

/**
 * Returns the maximum `line_plot_max_runs` value for full-screen panels,
 * configured via the `full_screen_line_plot_increased_max_runs` Statsig
 * dynamic config. Uses the 'max' strategy so the most permissive org wins.
 */
export const useFullScreenLinePlotMaxRunsDynamicConfig =
  (): NumericDynamicConfig => {
    return useViewerOrgsNumericDynamicConfig(
      'full_screen_line_plot_increased_max_runs',
      'line_plot_max_runs',
      'max'
    );
  };
